import { render, staticRenderFns } from "./RelationInfoModal.vue?vue&type=template&id=5ef0772b"
import script from "./RelationInfoModal.vue?vue&type=script&lang=js"
export * from "./RelationInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports